import { type Err } from '../CreateGroup/useCreateCampaignGroup'

import { useMutation } from '@percent/partner-dashboard/common/hooks/useMutation/useMutation'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export type UseArchiveCampaignGroupProps = Readonly<{
  onArchived: () => void
  onError: (error: Err) => void
}>

export type UseArchiveCampaignGroupReturn = Readonly<{
  isLoading: boolean
  archiveGroup: (id: string) => void
}>

const defaultError: Err = {
  code: 'error',
  message: 'error',
  title: 'error'
}

export const useArchiveCampaignGroup = ({
  onArchived,
  onError
}: UseArchiveCampaignGroupProps): UseArchiveCampaignGroupReturn => {
  const { workplaceGivingService } = useServices()

  const [{ isLoading }, { apiFunc: deleteCampaignGroup }] = useMutation(
    workplaceGivingService.deleteCampaignGroup,
    () => {
      onArchived()
    },
    error => {
      if (error) {
        onError(error.response?.data?.error ?? defaultError)
      }
    }
  )

  return {
    isLoading,
    archiveGroup: (id: string) => {
      deleteCampaignGroup(id)
    }
  }
}
